var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableNavigate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2176 11.3338C14.4482 11.3331 14.6667 11.4238 14.812 11.5805L18.4927 15.5805C18.7238 15.8265 18.7238 16.1811 18.4927 16.4271L14.6825 20.4271C14.4131 20.7106 13.9321 20.7494 13.608 20.5138C13.2839 20.2781 13.2396 19.8573 13.5089 19.5738L16.9152 16.0005L13.6232 12.4271C13.433 12.2273 13.3929 11.9489 13.5205 11.7141C13.6482 11.4792 13.9204 11.3307 14.2176 11.3338Z",
    fill: "#20232D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNavigate);
export default __webpack_public_path__ + "static/media/tableNavigate.795823bf6c810c0ff97163111a0a56ef.svg";
export { ForwardRef as ReactComponent };